import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tabStyles } from './tabs.styles';
import resetStyle from '../../shared/components/html-content/reset.style';
import { ludsBaseFont } from '../../shared/styles/typography';

/**
 * Tab component to be used within luds-tabs.
 * This component represents both the tab trigger and its associated content.
 */
@customElement('luds-tab')
export class LudsTab extends LitElement {
  static override styles = [resetStyle, ludsBaseFont, tabStyles];

  /**
   * The title text to display in the tab
   */
  @property({ type: String })
  override title = '';

  /**
   * Whether the tab is currently active
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * Whether the tab is disabled
   */
  @property({ type: Boolean, reflect: true })
  disabled = false;

  /**
   * Optional counter to display next to tab title
   */
  @property({ type: Number })
  counter?: number;

  /**
   * Whether to preserve the tab content when switching tabs
   * When true, the content is hidden but not removed from the DOM
   */
  @property({ type: Boolean })
  preserveContent = false;

  /**
   * Custom CSS class to apply to the tab content
   */
  @property({ type: String })
  class = '';

  /**
   * Render the tab content only if it's active or preserveContent is true
   */
  override render() {
    const shouldRenderContent = this.preserveContent || this.active;

    return html`
      ${shouldRenderContent
        ? html`
            <div ?hidden=${!this.active} class=${this.class || ''}>
              <slot></slot>
            </div>
          `
        : ''}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'luds-tab': LudsTab;
  }
}
